export default "__VITE_ASSET__GgYh7TZj__"